import { Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { Tooltip } from "@zapier/design-system-beta";

export const EXIT_TOUR = "Exit tour";

type CloseButtonProps = {
  onPress: () => void;
};

export function CloseButton({ onPress }: CloseButtonProps) {
  return (
    <Tooltip placement="top" content={EXIT_TOUR}>
      <Tooltip.FocusableTrigger>
        <Button
          variant="ghost"
          size="small"
          onPress={onPress}
          iconPosition="start"
        >
          <Icon name="formX" color="TextDefault" />
        </Button>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}
